module.exports = __webpack_public_path__ + "crib_andr_qr.0a52d5e.png";